import Vue from 'vue';
import Endpoints from '@/share/Endpoints';

export const getBenefitSectionsByOrg = async ({ commit }) => {
  try {
    const { data } = await Vue.axios({
      method: 'GET',
      url: Endpoints.benefitSectionsOrganization,
    });
    commit('setSections', data.sections || []);
    return { status: true, data };
  } catch (error) {
    return { status: false, message: error };
  }
};

export const getBenefitSectionsForMember = async ({ commit }) => {
  try {
    const { data } = await Vue.axios({
      method: 'GET',
      url: Endpoints.benefitSectionsMember,
    });
    commit('setSections', data.sections || []);
    return { status: true, data };
  } catch (error) {
    return { status: false, message: error };
  }
};

export const addBenefitSection = async ({ commit }, payload) => {
  try {
    const { data } = await Vue.axios({
      method: 'POST',
      url: Endpoints.benefitSectionsCreate,
      data: { section: payload },
    });
    return { status: true, data };
  } catch (error) {
    return { status: false, message: error };
  }
};

export const updateBenefitSection = async ({ commit }, { id, payload }) => {
  try {
    const { data } = await Vue.axios({
      method: 'PUT',
      url: Endpoints.benefitSectionsUpdate.replace(':sectionId', id),
      data: { section: payload },
    });
    return { status: true, data };
  } catch (error) {
    return { status: false, message: error };
  }
};

export const deleteBenefitSection = async ({ commit }, id) => {
  try {
    const { data } = await Vue.axios({
      method: 'DELETE',
      url: Endpoints.benefitSectionsDelete.replace(':sectionId', id),
    });
    return { status: true, data };
  } catch (error) {
    return { status: false, message: error };
  }
};
